/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * (tsType: Partial<Folder>, schemaOptions: { partial: true })
 */
export interface FolderPartial { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    /**
     * Nombre de la carpeta
     */
    name?: string;
    /**
     * Ruta completa de la carpeta
     */
    path?: string;
    parentId?: string;
    companyId?: string;
    /**
     * Módulo dueño de la carpeta. null = módulo de documentos; \"normativity\" = módulo de normatividad. Los listados del módulo de documentos filtran null
     */
    moduleKey?: string;
    /**
     * Categoría funcional (p. ej. \"covas\"). Aplica a la carpeta y a todo lo que cuelga de su ruta; null = sin categoría
     */
    category?: string;
    /**
     * Orden de visualización dentro de la carpeta padre
     */
    displayOrder?: number;
}

